import { FC } from 'react'

import { RadioButtonGroup } from '@sequencehq/core-components'

import { useCurrentListView } from '../../hooks/useCurrentListView'
import { ListView } from '../../inbox.types'

export const InboxListSwitch: FC = () => {
  const { currentView, setCurrentView } = useCurrentListView()

  return (
    <RadioButtonGroup<ListView>
      options={[
        { value: 'needsAction', label: 'Needs Action' },
        { value: 'all', label: 'All' }
      ]}
      value={currentView}
      onChange={setCurrentView}
      fullWidth
    />
  )
}
